import {
  FETCH_ADMINISTRATION_DATA,
  FETCH_ADMINISTRATION_EXTRA_DATA,
  FETCH_ADMINISTRATION_LIST_DATA,
  FETCH_VAT_OPTIONS,
  FETCH_ADMINISTRATION_DICTIONARIES, FETCH_ADMINISTRATION_BOOKKEEPING,
} from '../actions/types';
import { CREATE_DICTIONARIES, CREATE_EXTRA_DATA, CREATE_VAT_OPTIONS } from '../utils/adminstration-items-const';

export default function reportReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_ADMINISTRATION_DATA:
      return { ...state, administrationData: action.payload };
    case FETCH_ADMINISTRATION_EXTRA_DATA:
      return { ...state, administrationExtraData: CREATE_EXTRA_DATA(action.payload) };
    case FETCH_ADMINISTRATION_LIST_DATA:
      return { ...state, administrationListData: action.payload };
    case FETCH_VAT_OPTIONS:
      return { ...state, vatOptions: CREATE_VAT_OPTIONS(action.payload) };
    case FETCH_ADMINISTRATION_DICTIONARIES:
      return { ...state, dictionaries: CREATE_DICTIONARIES(action.payload) };
    case FETCH_ADMINISTRATION_BOOKKEEPING:
      return { ...state, administrationBookkeeping: action.payload };
    default:
      return state;
  }
}